export enum Category {
  phones = 'phones',
  tablets = 'tablets',
  accessories = 'accessories',
}
